import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  deliver_id: [
    {...makeRule('请选择物流公司', 'integer')},
  ],
  deliver_order_number: [
    {...makeRule('请输入物流单号', 'string')},
  ],

}



// WEBPACK FOOTER //
// ./src/views/fair-reward/fairReward.rules.js